import { PageContent, PageHeader } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BatchContent } from '../_components/detail/BatchContent';

const BatchPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('batch.details-page')}
        breadcrumbs={[
          {
            title: t('batch.page'),
            href: '/batch',
          },
          { title: t('batch.details-page') },
        ]}
      />
      <PageContent>
        <BatchContent />
      </PageContent>
    </>
  );
};

export default BatchPage;
